import type { NavLink } from '../types-company'

export const primaryNav: NavLink[] = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/catalog' },
  { label: 'Crop Solutions', to: '/crop-solutions' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
]

export const footerNav: { title: string; links: NavLink[] }[] = [
  {
    title: 'Explore',
    links: [
      { label: 'All Products', to: '/catalog' },
      { label: 'Crop Solutions', to: '/crop-solutions' },
      { label: 'Gallery', to: '/gallery' },
      { label: 'About Us', to: '/about' },
    ],
  },
  {
    title: 'Categories',
    links: [
      { label: 'Soil Biology', to: '/product-categories/soil-biology' },
      { label: 'Soil Improvers', to: '/product-categories/soil-improvers' },
      { label: 'Biostimulants', to: '/product-categories/biostimulants' },
      { label: 'Plant Strength', to: '/product-categories/plant-strength' },
      { label: 'Water Management', to: '/product-categories/water-management' },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'Contact', to: '/contact' },
      { label: 'Become a Retailer', to: '/retailer-enquiry' },
      { label: 'Become a Distributor', to: '/distributor-enquiry' },
      { label: 'Usage & Resources', to: '/resources' },
      { label: 'FAQ', to: '/faq' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/privacy-policy' },
      { label: 'Terms of Use', to: '/terms' },
      { label: 'Disclaimer', to: '/disclaimer' },
    ],
  },
]
